export default "__VITE_ASSET__DOFdGCFZ__"